import type { InjectionKey, Ref } from "vue";

export type AtsSearchTrackingContext = {
  searchId: string;
  savedSearchId?: string;
  missionId?: string;
};

const atsSearchTrackingContextKey: InjectionKey<Ref<AtsSearchTrackingContext | undefined>> =
  Symbol("atsSearchTrackingContext");

/** Lets the `talent_*` events fired under the ATS results page carry the search they come from. */
export const provideAtsSearchTrackingContext = (context: Ref<AtsSearchTrackingContext | undefined>) => {
  provide(atsSearchTrackingContextKey, context);
};

/** Some `talent_*` captures run in handlers, outside any component: there is no search context to inject there. */
export const useAtsSearchTrackingContext = () =>
  getCurrentInstance() ? inject(atsSearchTrackingContextKey, undefined) : undefined;
